import "./multi-collections-collection";

class MultiCollections extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("tab-component:tab-selected", (e) => {
      const { tab } = e.detail;

      this.querySelectorAll("[data-show-for]").forEach((image) => {
        const { showFor } = image.dataset;
        image.style.display = showFor === tab.id ? null : "none";
      });
    });
  }

  disconnectedCallback() {}
}

if (!customElements.get("multi-collections")) {
  customElements.define("multi-collections", MultiCollections);
}
